/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementBase,
  AgreementBaseOptional,
  AgreementBaseMetaI,
  AgreementBaseTrackedI,
} from "./agreement-base";
import { AgreementBaseTracked, AgreementBaseMeta } from "./agreement-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";

/**
 *
 * @export
 * @interface AgreementBaseDTO
 */
export interface AgreementBaseDTOOptional extends AgreementBaseOptional {
  /**
   *
   * @type {number}
   * @memberof AgreementBaseDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementBaseDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementBaseDTO
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementBaseDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementBaseDTO
   */
  sortOrder?: number;
}

export interface AgreementBaseDTO
  extends AgreementBaseDTOOptional, AgreementBase, AgreementRef {
  /**
   *
   * @type {number}
   * @memberof AgreementBaseDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof AgreementBaseDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementBaseDTO
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementBaseDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementBaseDTO
   */
  sortOrder?: number;
}

export interface AgreementBaseDTOTrackedI extends AgreementBaseOptional {
  /**
   *
   * @type {number}
   * @memberof AgreementBaseDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementBaseDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementBaseDTO
   */
  agreementName?: string;
  agreementNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementBaseDTO
   */
  isGlobal?: boolean;
  isGlobalIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementBaseDTO
   */
  sortOrder?: number;
  sortOrderIsSet: boolean;
}

transformDatesMap.set(
  "AgreementBaseDTO",
  function (model: AgreementBaseDTO) {},
);

export type AgreementBaseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isGlobal: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  sortOrder: PropertyMeta<MetaTypeBase<number>>;
}>;

export var AgreementBaseDTOMeta: AgreementBaseDTOMetaI =
  {} as AgreementBaseDTOMetaI;
AgreementBaseDTOMeta = typeMeta("AgreementBaseDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  agreementName: propertyMeta(
    "agreementName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isGlobal: propertyMeta(
    "isGlobal",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  sortOrder: propertyMeta(
    "sortOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = AgreementBaseDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([AgreementRefMeta]);
  metaI.assignId.inheritedFrom = AgreementRefMeta.assignId;
  metaI.tempID.inheritedFrom = AgreementRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([AgreementBaseMeta]);
  metaI.agreementName.inheritedFrom = AgreementBaseMeta.agreementName;
  metaI.isGlobal.inheritedFrom = AgreementBaseMeta.isGlobal;
  metaI.sortOrder.inheritedFrom = AgreementBaseMeta.sortOrder;
});

export class AgreementBaseDTOTracked
  extends AgreementBaseTracked
  implements AgreementBaseDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  agreementName__I?: string = undefined;
  agreementNameIsSet: boolean = false;
  set agreementName(v: undefined | string) {
    if (v !== undefined) {
      this.agreementName__I = v;
      this.agreementNameIsSet = true;
    } else {
      this.agreementName__I = v || undefined;
      this.agreementNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementName() {
    return this.agreementName__I;
  }
  isGlobal__I?: boolean = undefined;
  isGlobalIsSet: boolean = false;
  set isGlobal(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGlobal__I = v;
      this.isGlobalIsSet = true;
    } else {
      this.isGlobal__I = v || undefined;
      this.isGlobalIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGlobal() {
    return this.isGlobal__I;
  }
  sortOrder__I?: number = undefined;
  sortOrderIsSet: boolean = false;
  set sortOrder(v: undefined | number) {
    if (v !== undefined) {
      this.sortOrder__I = v;
      this.sortOrderIsSet = true;
    } else {
      this.sortOrder__I = v || undefined;
      this.sortOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get sortOrder() {
    return this.sortOrder__I;
  }
  constructor(config?: AgreementBaseDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: AgreementBaseDTOOptional,
    options?: AssignOptions,
  ): AgreementBaseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.agreementName &&
      this.agreementNameApplyFilter(optionsRequired.filter)
    ) {
      this.agreementName = config.agreementName;
      if (optionsRequired.unassign) this.agreementNameIsSet = false;
      else this.agreementNameIsSet = true;
    }
    if (config.isGlobal && this.isGlobalApplyFilter(optionsRequired.filter)) {
      this.isGlobal = config.isGlobal;
      if (optionsRequired.unassign) this.isGlobalIsSet = false;
      else this.isGlobalIsSet = true;
    }
    if (config.sortOrder && this.sortOrderApplyFilter(optionsRequired.filter)) {
      this.sortOrder = config.sortOrder;
      if (optionsRequired.unassign) this.sortOrderIsSet = false;
      else this.sortOrderIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AgreementBaseDTOTrackedI {
    const cloned = {} as AgreementBaseDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.agreementNameIsSetDeep() &&
      this.agreementNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementNameIsSet = true;
      cloned.agreementName = this.agreementName;
    } else {
      //cloned.agreementNameIsSet = false
    }
    if (
      this.isGlobalIsSetDeep() &&
      this.isGlobalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGlobalIsSet = true;
      cloned.isGlobal = this.isGlobal;
    } else {
      //cloned.isGlobalIsSet = false
    }
    if (
      this.sortOrderIsSetDeep() &&
      this.sortOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sortOrderIsSet = true;
      cloned.sortOrder = this.sortOrder;
    } else {
      //cloned.sortOrderIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AgreementBaseDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.agreementNameApplyFilter(filter)) this.agreementNameIsSet = false;

    if (!this.isGlobalApplyFilter(filter)) this.isGlobalIsSet = false;

    if (!this.sortOrderApplyFilter(filter)) this.sortOrderIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseDTOMeta.assignId,
      AgreementBaseDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseDTOMeta.tempID,
      AgreementBaseDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  agreementNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseDTOMeta.agreementName,
      AgreementBaseDTOMeta,
      this.agreementName,
      this,
    );
  }
  agreementNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementNameIsSet && this.agreementNameApplyFilter(filter))
      return true;

    return false;
  }
  isGlobalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseDTOMeta.isGlobal,
      AgreementBaseDTOMeta,
      this.isGlobal,
      this,
    );
  }
  isGlobalIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGlobalIsSet && this.isGlobalApplyFilter(filter)) return true;

    return false;
  }
  sortOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementBaseDTOMeta.sortOrder,
      AgreementBaseDTOMeta,
      this.sortOrder,
      this,
    );
  }
  sortOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sortOrderIsSet && this.sortOrderApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.agreementNameIsSetDeep(filter)) return true;
    if (this.isGlobalIsSetDeep(filter)) return true;
    if (this.sortOrderIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
